import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ArrowRight } from "lucide-react";

const NotFound = () => (
  <>
    <Helmet>
      <title>Page introuvable | Resineko</title>
      <meta name="description" content="La page demandée est introuvable." />
      <meta name="robots" content="noindex, follow" />
    </Helmet>
    <section className="flex min-h-screen items-center bg-[#0A0A0A]">
      <div className="mx-auto max-w-2xl px-5 text-center md:px-10">
        <p className="font-serif text-8xl font-light italic text-[#047857]">404</p>
        <h1 className="mt-6 font-serif text-4xl font-light text-[#F4F4F0]">Cette page n'existe pas</h1>
        <p className="mt-4 text-sm text-[#8C8C8C]">Le lien est peut-être rompu ou la page a été déplacée.</p>
        <Link
          to="/"
          data-testid="notfound-home-cta"
          className="group relative mt-10 inline-flex overflow-hidden bg-[#047857] px-8 py-4 text-xs font-medium uppercase tracking-[0.22em] text-white"
        >
          <span className="absolute inset-0 -translate-x-full bg-[#065F46] transition-transform duration-500 ease-out group-hover:translate-x-0" />
          <span className="relative flex items-center gap-3">Retour à l'accueil <ArrowRight size={14} /></span>
        </Link>
      </div>
    </section>
  </>
);

export default NotFound;
